/* eslint-disable react-hooks/exhaustive-deps */
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Flex,
  Input,
  IconButton,
  Icon,
  Spinner,
  ModalCloseButton,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Tooltip,
  Box,
  useDisclosure,
} from '@chakra-ui/react'
import React, { useCallback, useEffect, useState } from 'react'
import { FaCheck, FaTrashAlt } from 'react-icons/fa'
import debounce from 'lodash/debounce'
import { useLazyQuery, useMutation } from '@apollo/client'
import {
  GET_BOOKS_BY_SEARCH_ADMIN,
  UPDATE_BOOK_ADMIN_HOT,
} from 'services/book/graphql'
import { API_V2 } from 'constants/apollo'
import { FILTERS, ORDERING } from '../Filters/constants'
import ApplyBooleanModal from '../ApplyBooleanModal'

const ITEMS = 20

const SearchBookModal = ({ isOpen, onClose }) => {
  const [search, setSearch] = useState('')
  const [searchedBooks, setSearchedBooks] = useState([])
  const [releaseDateActive, setReleaseDateActive] = useState('')
  const [releaseDate, setReleaseDate] = useState('')
  const [saleDateActive, setSaleDateActive] = useState('')
  const [saleDate, setSaleDate] = useState('')
  const [saleValueActive, setSaleValueActive] = useState('')
  const [saleValue, setSaleValue] = useState('')
  const [applyData, setApplyData] = useState(null)
  const {
    isOpen: isApplyOpen,
    onOpen: onApplyOpen,
    onClose: onApplyClose,
  } = useDisclosure()

  const [updateStory, { loading: updateStoryLoading }] = useMutation(
    UPDATE_BOOK_ADMIN_HOT,
    {
      context: {
        clientName: API_V2,
      },
    },
  )

  const [getBooksBySearch, { loading: getBooksBySearchLoading }] = useLazyQuery(
    GET_BOOKS_BY_SEARCH_ADMIN,
    {
      fetchPolicy: 'network-only',
      context: {
        clientName: API_V2,
      },
    },
  )

  const handleSaleValueChange = e => {
    setSaleValue(Number(e.target.value))
  }

  const handleReleaseDateChange = e => {
    setReleaseDate(e.target.value)
  }
  const handleSaleDateChange = e => {
    setSaleDate(e.target.value)
  }

  const handleClearSearch = async () => {
    setSearch('')
    setSearchedBooks([])
  }

  const handleSearchChange = e => {
    setSearch(e.target.value)
  }

  const handleSearch = async search => {
    try {
      const { data } = await getBooksBySearch({
        variables: {
          searchPart: search,
          pagination: {
            offset: 0,
            count: ITEMS,
          },
          order: [{ field: FILTERS.TITLE, value: ORDERING.ASC }],
          filter: {},
        },
      })

      setSearchedBooks(data.data.books)
    } catch (error) {
      console.log('error', error)
    }
  }

  const handleUpdateStory = async (bookId, params) => {
    try {
      const { data } = await updateStory({
        variables: { book: { id: bookId }, params },
      })

      if (data.book.id === bookId) {
        setSearchedBooks(prevBooks =>
          prevBooks.map(book => (book.id === bookId ? data.book : book)),
        )
      }
    } catch (error) {
      console.log('error', error)
    }
  }

  console.log('searchedBooks', searchedBooks)
  // eslint-disable-next-line react-hooks/exhaustive-deps, no-magic-numbers
  const debouncedSearch = useCallback(debounce(handleSearch, 500), [])

  const isLoading = getBooksBySearchLoading || updateStoryLoading

  useEffect(() => {
    if (search) {
      debouncedSearch(search)
    } else {
      setSearchedBooks([])
    }
  }, [search])

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size='full'>
      <ModalOverlay bg='blackAlpha.400' />
      <ModalContent borderRadius='lg' boxShadow='2xl' bg='white' mx='auto'>
        <ModalCloseButton />
        <ModalBody>
          {isLoading && (
            <Flex
              position='absolute'
              top='0'
              left='0'
              w='100%'
              h='100%'
              justify='center'
              align='center'
            >
              <Spinner size='xl' color='purple.500' />
            </Flex>
          )}
          <Flex gap='10px'>
            <Input
              placeholder='Search'
              value={search}
              onChange={handleSearchChange}
              w='335px'
            />

            <IconButton
              icon={<Icon as={FaTrashAlt} color='purple.500' />}
              onClick={handleClearSearch}
            />
          </Flex>

          <Flex
            w='100%'
            mt={6}
            borderRadius='lg'
            boxShadow='lg'
            overflowX='auto'
            bg='white'
            p={4}
          >
            <Table size='md'>
              <Thead bg='purple.50'>
                <Tr>
                  <Th fontWeight='bold' color='purple.700' fontSize='md' py={3}>
                    Title
                  </Th>
                  <Th fontWeight='bold' color='purple.700' fontSize='md' py={3}>
                    Slug
                  </Th>
                  <Th fontWeight='bold' color='purple.700' fontSize='md' py={3}>
                    Release Date
                  </Th>
                  <Th fontWeight='bold' color='purple.700' fontSize='md' py={3}>
                    Is Released
                  </Th>
                  <Th fontWeight='bold' color='purple.700' fontSize='md' py={3}>
                    Sale Date
                  </Th>
                  <Th fontWeight='bold' color='purple.700' fontSize='md' py={3}>
                    Sale Value
                  </Th>
                  <Th fontWeight='bold' color='purple.700' fontSize='md' py={3}>
                    Is Hot
                  </Th>
                  <Th fontWeight='bold' color='purple.700' fontSize='md' py={3}>
                    Is Listenable
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {searchedBooks.map(book => {
                  const colorByStatus = book.deleted
                    ? 'red.100'
                    : book.status === 'APPROVED'
                    ? 'green.100'
                    : 'gray.100'

                  return (
                    <Tr
                      key={book.id}
                      _hover={{ bg: 'purple.25' }}
                      bg={colorByStatus}
                      transition='background 0.2s'
                    >
                      <Tooltip label={book.id} placement='top' hasArrow>
                        <Td py={2} px={3} color='gray.800'>
                          {book.title}
                        </Td>
                      </Tooltip>
                      <Td py={2} px={3} color='gray.600' fontSize='sm'>
                        {book.slug}
                      </Td>
                      <Td
                        py={2}
                        px={3}
                        color='gray.700'
                        onClick={() => {
                          setReleaseDateActive(curr => (!curr ? book.id : ''))
                        }}
                        textAlign='center'
                      >
                        {releaseDateActive === book.id
                          ? ''
                          : book.releaseDate
                          ? new Date(book.releaseDate).toLocaleDateString()
                          : ''}
                        {releaseDateActive === book.id && (
                          <Flex>
                            <Input
                              type='date'
                              value={releaseDate}
                              onChange={handleReleaseDateChange}
                              autoFocus
                              onFocus={e =>
                                e.target.showPicker && e.target.showPicker()
                              }
                            />
                            <IconButton
                              icon={<Icon as={FaCheck} color='green.500' />}
                              isDisabled={!releaseDate}
                              onClick={() => {
                                setApplyData({
                                  title: 'Apply release date',
                                  description: `Are you sure you want to apply release date = ${releaseDate} to ${book.title}?`,
                                  onApply: () => {
                                    handleUpdateStory(book.id, { releaseDate })
                                    setReleaseDateActive('')
                                    setReleaseDate('')
                                    onApplyClose()
                                  },
                                  onCancel: () => {
                                    setReleaseDateActive('')
                                    setReleaseDate('')
                                    onApplyClose()
                                  },
                                })
                                onApplyOpen()
                              }}
                            />
                            <IconButton
                              icon={
                                <Icon
                                  as={FaTrashAlt}
                                  color='red.500'
                                  fontSize='16px'
                                />
                              }
                              bg='transparent'
                              onClick={e => {
                                console.log('clicked A')
                                e.stopPropagation()
                                setReleaseDateActive('')
                                setReleaseDate('')
                              }}
                            />
                          </Flex>
                        )}
                      </Td>
                      <Td py={2} px={3}>
                        <Flex
                          align='center'
                          justify='center'
                          cursor='pointer'
                          onClick={() => {
                            setApplyData({
                              title: 'Apply isReleased',
                              description: `Are you sure you want to apply isReleased = ${!book.isReleased} to ${
                                book.title
                              }?`,
                              onApply: () => {
                                handleUpdateStory(book.id, {
                                  isReleased: !book.isReleased,
                                })
                                onApplyClose()
                              },
                              onCancel: () => {
                                setApplyData(null)
                                onApplyClose()
                              },
                            })
                            onApplyOpen()
                          }}
                        >
                          <Box
                            w={3}
                            h={3}
                            borderRadius='full'
                            bg={book.isReleased ? 'green.400' : 'red.300'}
                            mr={2}
                          />
                          <Box
                            color={book.isReleased ? 'green.700' : 'red.600'}
                            fontWeight='medium'
                          >
                            {book.isReleased ? 'Yes' : 'No'}
                          </Box>
                        </Flex>
                      </Td>
                      <Td
                        py={2}
                        px={3}
                        color='gray.700'
                        onClick={() => {
                          setSaleDateActive(curr => (!curr ? book.id : ''))
                        }}
                        textAlign='center'
                      >
                        {saleDateActive === book.id
                          ? ''
                          : book.saleDate
                          ? new Date(book.saleDate).toLocaleDateString()
                          : ''}
                        {saleDateActive === book.id && (
                          <Flex>
                            <Input
                              type='date'
                              value={saleDate}
                              onChange={handleSaleDateChange}
                              autoFocus
                              onFocus={e =>
                                e.target.showPicker && e.target.showPicker()
                              }
                            />
                            <IconButton
                              icon={<Icon as={FaCheck} color='green.500' />}
                              isDisabled={!saleDate}
                              onClick={() => {
                                setApplyData({
                                  title: 'Apply sale date',
                                  description: `Are you sure you want to apply sale date = ${saleDate} to ${book.title}?`,
                                  onApply: () => {
                                    handleUpdateStory(book.id, { saleDate })
                                    setSaleDateActive('')
                                    setSaleDate('')
                                    onApplyClose()
                                  },
                                  onCancel: () => {
                                    setSaleDateActive('')
                                    setSaleDate('')
                                    onApplyClose()
                                  },
                                })
                                onApplyOpen()
                              }}
                            />
                            <IconButton
                              icon={
                                <Icon
                                  as={FaTrashAlt}
                                  color='red.500'
                                  fontSize='16px'
                                />
                              }
                              bg='transparent'
                              onClick={e => {
                                console.log('clicked B')
                                e.stopPropagation()
                                setSaleDateActive('')
                                setSaleDate('')
                              }}
                            />
                          </Flex>
                        )}
                      </Td>
                      <Td
                        py={2}
                        px={3}
                        color='gray.700'
                        onClick={() => {
                          setSaleValueActive(curr => (!curr ? book.id : ''))
                        }}
                        textAlign='center'
                        cursor='pointer'
                      >
                        {saleValueActive === book.id
                          ? ''
                          : book.saleValue
                          ? book.saleValue
                          : ''}
                        {saleValueActive === book.id && (
                          <Flex>
                            <Input
                              type='number'
                              value={saleValue}
                              onChange={handleSaleValueChange}
                              autoFocus
                              onFocus={e =>
                                e.target.showPicker && e.target.showPicker()
                              }
                            />
                            <IconButton
                              icon={<Icon as={FaCheck} color='green.500' />}
                              isDisabled={!saleValue}
                              onClick={() => {
                                setApplyData({
                                  title: 'Apply sale value',
                                  description: `Are you sure you want to apply sale value = ${saleValue} to ${book.title}?`,
                                  onApply: () => {
                                    handleUpdateStory(book.id, { saleValue })
                                    setSaleValueActive('')
                                    setSaleValue('')
                                    onApplyClose()
                                  },
                                  onCancel: () => {
                                    setSaleValueActive('')
                                    setSaleValue('')
                                    onApplyClose()
                                  },
                                })
                                onApplyOpen()
                              }}
                            />
                            <IconButton
                              icon={
                                <Icon
                                  as={FaTrashAlt}
                                  color='red.500'
                                  fontSize='16px'
                                />
                              }
                              bg='transparent'
                              onClick={e => {
                                e.stopPropagation()
                                setSaleValueActive('')
                                setSaleValue('')
                              }}
                            />
                          </Flex>
                        )}
                      </Td>
                      <Td py={2} px={3}>
                        <Flex
                          align='center'
                          justify='center'
                          cursor='pointer'
                          onClick={() => {
                            setApplyData({
                              title: 'Apply isHot',
                              description: `Are you sure you want to apply isHot = ${!book.isHot} to ${
                                book.title
                              }?`,
                              onApply: () => {
                                handleUpdateStory(book.id, {
                                  isHot: !book.isHot,
                                })
                                onApplyClose()
                              },
                              onCancel: () => {
                                setApplyData(null)
                                onApplyClose()
                              },
                            })
                            onApplyOpen()
                          }}
                        >
                          <Box
                            w={3}
                            h={3}
                            borderRadius='full'
                            bg={book.isHot ? 'green.400' : 'red.300'}
                            mr={2}
                          />
                          <Box
                            color={book.isHot ? 'green.700' : 'red.600'}
                            fontWeight='medium'
                          >
                            {book.isHot ? 'Yes' : 'No'}
                          </Box>
                        </Flex>
                      </Td>
                      <Td py={2} px={3}>
                        <Flex
                          align='center'
                          justify='center'
                          cursor='pointer'
                          onClick={() => {
                            setApplyData({
                              title: 'Apply isListenable',
                              description: `Are you sure you want to apply isListenable = ${!book.isListenable} to ${
                                book.title
                              }?`,
                              onApply: () => {
                                handleUpdateStory(book.id, {
                                  isListenable: !book.isListenable,
                                })
                                onApplyClose()
                              },
                            })
                            onApplyOpen()
                          }}
                        >
                          <Box
                            w={3}
                            h={3}
                            borderRadius='full'
                            bg={book.isListenable ? 'green.400' : 'red.300'}
                            mr={2}
                          />
                          <Box
                            color={book.isListenable ? 'green.700' : 'red.600'}
                            fontWeight='medium'
                          >
                            {book.isListenable ? 'Yes' : 'No'}
                          </Box>
                        </Flex>
                      </Td>
                    </Tr>
                  )
                })}
              </Tbody>
            </Table>
          </Flex>
        </ModalBody>
        {isApplyOpen && applyData && (
          <ApplyBooleanModal
            isOpen={isApplyOpen}
            onClose={onApplyClose}
            onApply={applyData.onApply}
            onCancel={applyData.onCancel}
            title={applyData.title}
            description={applyData.description}
          />
        )}
      </ModalContent>
    </Modal>
  )
}

export default SearchBookModal
